import React from "react";
import PropTypes from "prop-types";
import getContent from "pp-react-l10n";
import VideoModalPlayer from "./VideoModalPlayer";
import getHTMLElement from "../lib/setHtmlHelper";
import formatDate from "../lib/dateHelper";

const MostPopularArticlesHome = ({ country, timezone, language, popArticlesHomeInfo }) => {
  const getListContent = getContent("staticContent");
  return (
    <div>
      <div className="resultsContainer">
        <div className="resultslistcontainer">
          <ul className="results_list">
            {popArticlesHomeInfo.length > 0 ? (
              popArticlesHomeInfo.map((tile, index) => {
                const updatedDate = formatDate({
                  dateToFormat: tile.updated_time,
                  country,
                  timezone,
                  language,
                });
                const listItemId = `tile-list-item-${index}`;
                return (
                  <li className="results" key={index}>
                    <hr className="article-divider" />
                    <a
                      data-pa-click={JSON.stringify({
                        link: `MostPopularArticlesHome-link-${tile.url_slug}`,
                        event_name: "brc_categoryListArticle_clicked"
                      })}
                      className="arrow resultsBtn"
                      href={`/${country}/brc/article/${tile.url_slug}`}
                    />
                    <div className="results-image">
                      {!tile.sm_bg ? (
                        <span />
                      ) : (
                        <div
                          className="set-image"
                          style={{ backgroundImage: `url(${tile.sm_bg})` }}
                        >
                          <VideoModalPlayer
                            source={tile.content}
                            id={listItemId}
                          />
                        </div>
                      )}
                    </div>
                    <div className="results-content">
                      <h2
                        className="vx_text-5 results_cat"
                        key={tile.category + index}
                      >
                        {tile.category && tile.category.toUpperCase()}{" "}
                      </h2>
                      <h2 className="results_heading">
                        <a
                          className="results_heading"
                          data-pa-click={JSON.stringify({
                            link: `MostPopularArticlesHome-link-${tile.url_slug}`,
                            event_name: "brc_popularArticle_clicked"
                          })}
                          href={`/${country}/brc/article/${tile.url_slug}`}
                          key={tile.heading + index}
                        >
                          {" "}
                          {getHTMLElement(tile.heading, { useHTML: true })}
                        </a>
                      </h2>
                      <div
                        className="vx_text-body_secondary results_date"
                        key={updatedDate + index}
                      >
                        {updatedDate === "Invalid date" ? "" : updatedDate}
                      </div>
                      <div
                        className="vx_text-body results_description"
                        key={tile.desc + index}
                      >
                        {" "}
                        {getHTMLElement(tile.desc, { useHTML: true })}{" "}
                      </div>
                    </div>
                  </li>
                );
              })
            ) : (
              <div className="noArticlesFound">
                <h2> {getListContent("brc.noArticlesFound")}</h2>
              </div>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

MostPopularArticlesHome.propTypes = {
  country: PropTypes.string,
  timezone: PropTypes.string,
  language: PropTypes.string,
  popArticlesHomeInfo: PropTypes.array,
};

export default MostPopularArticlesHome;
